import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20pastel%20product%20flat%20lay%20featuring%20baby%20shoes%20hoodies%20t-shirts%20perfume%20bottles%20and%20fashion%20accessories%20arranged%20artistically%20on%20light%20cream%20background%20with%20gentle%20shadows%20clean%20editorial%20style%20minimalist%20composition%20warm%20neutral%20tones%20European%20aesthetic%20high%20key%20lighting%20airy%20atmosphere%20no%20text%20no%20logos&width=1920&height=1080&seq=yoybuy-hero-bg-01&orientation=landscape"
          alt="YOYBUY товары"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      <div className="relative z-10 flex flex-col justify-end h-full pb-24 md:pb-32 px-6 md:px-16">
        <div className="max-w-3xl">
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/80 text-xs md:text-sm font-label tracking-wide mb-5">
            YOYBUY SPREADSHEET
          </span>
          <h1 className="text-4xl md:text-7xl lg:text-8xl font-heading font-semibold text-white leading-[1.05] mb-4">
            Buy It Now
          </h1>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-light text-white/90 leading-tight mb-8">
            YOYBUY Spreadsheet
          </h2>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              yoybuy sheet
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/60 text-white px-8 py-3.5 rounded-full text-base font-semibold hover:bg-white/10 transition-all whitespace-nowrap"
            >
              buy it now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-8 z-10 hidden md:block">
        <a href="#categories" className="w-10 h-16 border-2 border-white/30 rounded-full flex items-start justify-center pt-3 hover:border-white/60 transition-colors">
          <span className="w-1.5 h-3 bg-white/50 rounded-full animate-bounce"></span>
        </a>
      </div>
    </section>
  );
}